import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import Swiper from 'swiper/swiper-bundle.min.js'

$(document).ready(function(){
  var swiper1 = new Swiper(".mySwiper", {
    allowTouchMove: false,
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    on:{
      init: function(swiper){
        $('.section1 .sec1-tab div').eq(0).addClass('active')
      },
      slideChangeTransitionStart: function(){
        $('.section1 .sec1-tab div').eq(this.realIndex).addClass('active').siblings().removeClass('active')
      },
    },
  })
  $('.section1 .sec1-tab div').on('click',function(){
    let index = $(this).index()
    swiper1.slideTo(index)
  })
})